import { rem } from '@heathmont/moon-utils';
import { css } from 'styled-components';
import media from '~/client/shared/media';

const basicImageStyle = css`
  object-fit: cover;
  border-radius: ${rem(4)} ${rem(4)} 0 0;
  display: block;
  width: 100%;
  max-width: 100%;
  height: ${rem(160)};
  ${media.phoneMedium} {
    height: ${rem(164)};
  }
  ${media.tabletSmall} {
    height: ${rem(192)};
  }
  ${media.tabletMedium} {
    height: ${rem(212)};
  }
  ${media.desktopSmall} {
    height: ${rem(272)};
  }
`;

export default basicImageStyle;
